import html2canvas from 'html2canvas';

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export async function exportNodeAsImage(node, { format = 'png', filename = 'lista-expres', scale = 2 } = {}) {
  if (!node) throw new Error('Nodo de preview no disponible');
  const canvas = await html2canvas(node, {
    scale,
    useCORS: true,
    allowTaint: true,
    backgroundColor: '#0b1220',
    logging: false
  });
  const mime = format === 'jpg' || format === 'jpeg' ? 'image/jpeg' : 'image/png';
  const quality = mime === 'image/jpeg' ? 0.92 : undefined;
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, mime, quality));
  if (!blob) throw new Error('No se pudo generar la imagen');
  const ext = mime === 'image/jpeg' ? 'jpg' : 'png';
  downloadBlob(blob, `${filename}.${ext}`);
  return { ok: true, bytes: blob.size, mime };
}

export async function shareImageIfPossible(node, { title = 'Lista comercial', text = '' } = {}) {
  if (!node || typeof navigator === 'undefined' || !navigator.share) {
    return { ok: false, reason: 'share_unsupported' };
  }
  const canvas = await html2canvas(node, { scale: 2, useCORS: true, backgroundColor: '#0b1220' });
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
  if (!blob) return { ok: false, reason: 'blob_failed' };
  const file = new File([blob], 'lista-expres.png', { type: 'image/png' });
  if (navigator.canShare && !navigator.canShare({ files: [file] })) {
    return { ok: false, reason: 'files_unsupported' };
  }
  await navigator.share({ title, text, files: [file] });
  return { ok: true };
}
